/*
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-04-19 10:15:07
 * @LastEditors: enbo.zhou@dsicm.com
 * @LastEditTime: 2021-06-21 18:36:20
 * @FilePath: /dsicm-admin-web/src/views/treatment/api/index.js
 */
import request from '@/utils/req.js';


// 分类保存
export function decisionTypeSave(params) {
    return request.post("/admin/decision-tree-type/save", params);
}

//分类分页列表
export function decisionTypePage(params) {
    return request.post("/admin/decision-tree-type/page",params);
}
//分类分页列表
export function decisionTypeList(params) {
    return request.post("/admin/decision-tree-type/list",params);
}


//获取详情
export function decisionTypeDetail(id) {
    return request.get(`/admin/decision-tree-type/${id}`);
}
//删除
export function deleteDecisionType(id) {
    return request.delete(`/admin/decision-tree-type/${id}`);
}
//逻辑编辑分页列表
export function decisionTreePage(params) {
    return request.post("/admin/decision-tree/page",params);
}
//逻辑编辑添加
export function decisionTreeInsertReturnId(params) {
    return request.post("/admin/decision-tree/insertReturnId", params);
}
//逻辑编辑发布
export function decisionTreePublish(params) {
    return request.put("/admin/decision-tree/publish", params);
}
//逻辑编辑提交审核
export function decisionTreeSubmitApproval(params) {
    return request.post("/admin/decision-tree/submitApproval", params);
}
//逻辑审核
export function decisionTreeApproval(params) {
    return request.put("/admin/decision-tree/approve", params);
}
//患者分页
export function patientSchemePage(params) {
    return request.post("/admin/patient-scheme-decision-tree/page", params);
}
//逻辑发布
export function patientSchemePublish(params) {
    return request.put("/admin/patient-scheme-decision-tree/publish/" + params);
}
//引用模板逻辑
export function quoteDecisionTree(params) {
    return request.post(`/admin/decision-tree/quoteDecisionTree/${params.id}`);
}

//获取患者详情
export function patientSchemeGetDetail(params) {
    return request.get("/admin/patient-scheme-decision-tree/"+ params);
}
//逻辑编辑取消审核
export function cancelApproval(params) {
    return request.put("/admin/decision-tree/cancelApproval/"+ params);
}
//逻辑编辑详情
export function decisionTreeDetail(params) {
    return request.get("/admin/decision-tree/"+ params);
}
export function decisionTreeInsertUpdate(params) {
    return request.put("/admin/decision-tree", params);
}
export function decisionTreeDelete(params) {
    return request.delete("/admin/decision-tree/"+ params);
}

//进入问诊房间 (获取房间问诊状态)
export function apiIntoInquiryRoom(params) {
    return request.post("/admin/inquiry-info/intoInquiryRoom", params);
}

//患者全病程处理接口
export function apiWholeCourseHandler(params) {
    return request.get(`/admin/whole-course/handler/${params}`);
}
//获取历史消息列表
export function apiGgetRecordByRoomCode(params) {
    return request.post("/admin/chat-record/getRecordByRoomCode", params);
}
///疾病类型列表查询
export function apiDiseaseType(params) {
    return request.get("/admin/disease-type", params);
}
//任务提醒分页列表适配admin2.0页面接口
export function apiCaseMgrTaskPage(params) {
    return request.post("/admin/case-mgr-task/v2/page", params);
}

//反馈处理分页列表适配admin2.0页面接口
export function apiFeedbackPage(params) {
    return request.post("/admin/feedback/v2/page", params);
}
///
//反馈处理分页列表适配admin2.0页面接口
export function apiPatientFiles(params) {
    return request.post("/admin/patient-files/v2/page", params);
}
//打卡异常分页列表适配admin2.0页面接口
export function apiPatientTask(params) {
    return request.post("/admin/patient-task/v2/page", params);
}
//单个患者任务接口admin2.0
export function apiGetByWholeCourseId(params) {
    // return request.post(`/admin/patient-task/getByWholeCourseId?status=${params.status}&wholeCourseId=${params.wholeCourseId}`);
    return request.get(`/admin/patient-task/getPatientTaskAbnormal/${params.wholeCourseId}`)
}
//新版ui界面个案任务接口
export function apiCaseGetByWholeCourseId(params) {
    return request.post(`/admin/case-mgr-task/getByWholeCourseId?wholeCourseId=${params}`);
}
//查询问诊列表-admin,新ui 专项对话
export function apiGetInquiryPageOnAdmin(params) {
    return request.post(`/admin/inquiry-info/getInquiryPageOnAdmin`, params);
}

// 查询医护对话左侧患者列表
export function apiGetDoctorNursePageOnAdmin(params) {
    return request.post(`/admin/patient-doctor-confirm/doctorNurse/page`, params);
}

//获取当前个案所在个案组ID
export function apiGetCaseMgrGroupId(params) {
    return request.get("/admin/user-info/getCaseMgrGroupId", params);
}

//发送续约提醒
export function sendRenewalReminder(params) {
    return request.get("/admin/whole-course/sendRenewalReminder", params);
}

// 患者反馈评估问卷
export function getPatientFeedbackByWholeCourseId(params) {
    return request.post('/admin/feedback/getPatientFeedbackByWholeCourseId', params);
}

// 反馈评估问卷发送
export function sendFeedback(feedbackId) {
    return request.post(`/admin/feedback/sendFeedback/${feedbackId}`);
}

// 获取问卷详情
export function getAnswerSheetLog(params) {
    return request.get("/admin/qs-answer-sheet/getAnswerSheetLog", params);
}

// 关闭数据异常提醒
export function patientAnomalyClose(params) {
    return request.put("/admin/patient-anomaly", params);
}

// 设置自定义名称
export function setCustomName(params) {
    return request.get("/admin/chat-record/setCustomName", params);
}

// 获取下一张图片
export function nextImage(params) {
    return request.get("/admin/chat-record/nextImage", params);
}

// 获取上一张图片
export function preImage(params) {
    return request.get("/admin/chat-record/preImage", params);
}
export function sendTimMessage(params) {
    return request.post('/admin/chat-room/sendTimMessage', params);
}
//保存模板逻辑树
export function upDecisionTree(params) {
    return request.put('/admin/decision-tree', params);
}
//逻辑树详情
export function decisionTreeDetails(params) {
    return request.get(`/admin/decision-tree/${params}`, {});
}
//保存患者逻辑树
export function upPatientTree(params) {
    return request.put('/admin/patient-scheme-decision-tree', params);
}
//患者逻辑树详情
export function patientTreeDetails(params) {
    return request.get(`/admin/patient-scheme-decision-tree/${params}`, {});
}
//逻辑树检查
export function checkDecisionTree(params) {
    return request.post(`/admin/decision-tree/checkTreeJson`,params);
}
//获取线下机构
export function apiDepartmentScreen(params) {
    return request.post("/admin/hospital/listPullDown",params);
}

//获取患者推送包
export function listForDropList(params) {
    console.log(params,"params");
    return request.get(`/admin/push-package/page`,params);
}